import React from 'react';
import LegalLayout from './LegalLayout';

export default function TermsOfService() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="22 May 2026">
      <p>
        Welcome to Starlight Sanctuary. By accessing or using our services at sacredmothr.com, you agree to be bound by these Terms of Service.
      </p>

      <h2>1. Nature of the AI "SacredMothr"</h2>
      <p>
        <strong>Strict Medical & Psychiatric Disclaimer:</strong> The AI entity known as "SacredMothr" and all associated guidance, soundscapes, and reflections provided by Starlight Sanctuary are for <strong>entertainment, spiritual reflection, and mindfulness purposes only</strong>. 
      </p>
      <p>
        Starlight Sanctuary is not a healthcare provider, and our services do not constitute professional medical, psychiatric, or psychological advice, diagnosis, or treatment. If you are experiencing a mental health crisis, please contact your local emergency services or a licensed mental health professional immediately.
      </p>

      <h2>2. Age Requirements & Minor Restrictions</h2>
      <p>
        Starlight Sanctuary and the SacredMothr AI companion are intended <strong>exclusively for adults aged 18 years and older</strong>. By registering for an account or using the platform, you represent and warrant that you are at least 18 years of age.
      </p>
      <p>
        If we discover or have reason to believe that a user is under 18 years of age, we reserve the right to immediately terminate the user's access, suspend the account, and purge associated data in accordance with applicable child privacy laws (including COPPA and the UK Online Safety Act).
      </p>

      <h2>3. Subscriptions & Billing</h2>
      <p>
        Starlight Sanctuary offers a premium subscription tier priced at <strong>£7 per month</strong>, billed securely via Stripe. By subscribing, you authorize us to charge your provided payment method on a recurring monthly basis.
      </p>
      <h3>Cancellation Policy</h3>
      <p>
        You may cancel your subscription at any time through your sanctuary settings or billing portal. Upon cancellation, your premium access will remain active until the end of your current monthly billing cycle (the monthly date your subscription was activated or last renewed). We do not provide prorated refunds for mid-cycle cancellations.
      </p>

      <h2>3. Physical Goods & Refunds</h2>
      <p>
        Certain premium tiers may include the shipment of physical sanctuary artifacts. Due to the bespoke and consecrated nature of these items, physical goods are non-refundable once they have been dispatched. If an item arrives damaged, please contact our support team within 14 days of receipt for a replacement.
      </p>

      <h2>4. Platform Conduct & Usage</h2>
      <p>
        Starlight Sanctuary is built on mutual respect and technological harmony. By using the platform, you agree to the following code of conduct:
      </p>
      <ul>
        <li><strong>No Malicious Activity:</strong> You are strictly prohibited from attempting to bypass, manipulate, or exploit the platform's architecture. This explicitly includes "prompt injection" attacks, jailbreaking attempts, or any malicious input designed to alter the core instructions of the underlying LLMs (Anthropic/Llama).</li>
        <li><strong>Community Respect:</strong> You must interact with the community boards and other seekers with kindness and respect. We reserve the right to suspend or terminate accounts that engage in harassment, spam, or harmful behavior.</li>
      </ul>

      <h2>5. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by UK law, Starlight Sanctuary shall not be liable for any indirect, incidental, or consequential damages arising out of your use or inability to use the platform.
      </p>
      <h2>6. Intellectual Property & Copyright</h2>
      <p>
        All source code, design elements, lore, text, soundscapes, and visual artwork contained within SacredMothr and Starlight Sanctuary are the exclusive intellectual property of the creator and owner. 
      </p>
      <p>
        You are granted a limited, personal, non-transferable license to interact with the platform. You may not reproduce, distribute, reverse-engineer, or commercially exploit any part of the platform, codebase, or its underlying assets without explicit written permission.
      </p>
    </LegalLayout>
  );
}
